import { useEffect, useRef } from 'react';

import { Nullish } from '@tager/web-core';

export const usePrevTotal = (amount: Nullish<number>) => {
  const ref = useRef(amount);
  useEffect(() => {
    if (!isNaN(Number(amount)) && amount !== ref.current) {
      ref.current = amount;
    }
  }, [amount]);

  return ref.current;
};
